import React from "react";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { Network } from 'vis-network';

const RootCauseAnalysisRulesGraph = () => {
    const { t } = useTranslation();
    const container = useRef(null);
    //const language = localStorage.getItem("i18nextLng")
    //const ariza = language==='tr'?"ARIZA":"FAILURE"

    
const fsmnodesedges = [ 
  ["[K1]","[S2]","[S3]","[S2]<[S3]","[K1]<[S2]", "[ARIZA]"],
  [     
    {id: '[K1]', source: '[K1]',         target: '[S2]<[S3]', label: '0.83'},
    {id: '[K1]', source: '[K1]',         target: '[S3]', label: '0.83'},
    {id: '[K1]', source: '[K1]',         target: '[S2]', label: '0.83'},
    {id: '[S2]<[S3]', source: '[S2]<[S3]',         target: '[ARIZA]', label: '1.00'},
    {id: '[S2]', source: '[S2]',         target: '[S3]', label: '1.00'},
    {id: '[K1]<[S2]', source: '[K1]<[S2]',         target: '[S3]', label: '1.00'},
    {id: '[S3]', source: '[S3]',         target: '[ARIZA]', label: '1.00'},


  ]
  ]

    const nodes = []
    const edges = []
    if (fsmnodesedges) {
    const nodesfrompython = fsmnodesedges[0];
    const edgesfrompython = fsmnodesedges[1];
    if (nodesfrompython) {
        for (let ii = 0; ii < nodesfrompython.length; ii++) {
            const tmp = {
              id: nodesfrompython[ii],
              label: nodesfrompython[ii], 
              font: {
                color: nodesfrompython[ii]==="[ARIZA]"?"red":"black",
                font: nodesfrompython[ii]==="[ARIZA]"?"bold":"italic",
                background: "rgb(255,255,150)",
                align: "horizontal",
                vadjust: 1
              },
            }
            nodes.push(tmp)
          }
          for (let jj = 0; jj < edgesfrompython.length; jj++) {
            const tmp = {
              label: edgesfrompython[jj]["label"], 
              from: edgesfrompython[jj]["source"],
              to: edgesfrompython[jj]["target"],
              font: {
                color: "darkgreen",
                background: "white",
                size: "14",
                align: "horizontal",
                vadjust: 1
              },
            }
            edges.push(tmp)
          }
    }
  }



  const options = {
    physics: {
      enabled: false,
      stabilization: true
    },

    layout: {

      improvedLayout: true,
      hierarchical: {
        enabled: false,
        blockShifting: true,
        edgeMinimization: true,
        parentCentralization: false,
        shakeTowards: "leaves", // roots, leaves

      },
      interaction: { dragNodes: true }
    },
    interaction: {
      selectable: true,
      selectConnectedEdges: true
    },
    edges: {
      shadow: {
        enabled: false,
        color: "rgba(0,0,0,.5)",
        size: 1,
        x: 1,
        y: 1,
      },
      smooth: {
        enabled: true,
        type: "diagonalCross",
        roundness: 0.5,
        forceDirection: "none"
      },
      arrows: {
        to: {
          enabled: true,
          scaleFactor: 1.0,
          type: "arrow"
        },

      },
      color: {color: "rgb(0,0,150)", highlight: "rgb(255,127,127)"},
      width: 1.5,
    },
    nodes: {
      shape: "circle",
      size: 16,
      font: {size: 12, color: "rgb(0,0,0)",},
      borderWidth: 3,
      color: { background: "rgb(255,255,150)", border: "rgb(0,0,150)", highlight: "rgb(255,127,127)" },
    },

  };

  useEffect(() => {
    const network =
      container.current &&
      new Network(container.current, { nodes, edges }, options);
      console.log(network)
        // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [container, nodes, edges]);

  return (
    <div className="w-[50%] p-6 flex flex-col items-center bg-gray-50">
      <div className="border border-gray-400 rounded-lg p-6 w-full bg-white shadow-lg">
        {/* Header */}
        <h2 className="text-xl font-bold text-blue-600 text-center">{t("Kural_Grafigi")}</h2>
        
        <div ref={container} className='w-full h-[500px] border-2' />
        
      </div>

    </div>
  );
};

export default RootCauseAnalysisRulesGraph;
